import axios from '../api/axios';

export default {
    getStatisticsList({params, callback}){ // 列表
        axios.post(`/v1/admin/venueFees/statisticsList`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    getPlatformFeesList({params, callback}){ // 列表详情
        axios.post(`/v1/admin/venueFees/platformFeesList`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    pay({params, callback}){ // 重新支付
        axios.put(`/v1/admin/venueFees/chargeAgain`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/fee.js